import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';

const MoveCategoryDialog = ({ idToMove, updateCategory, handleClose }) => {
    const { allCategoriesState } = useSelector(state => ({
        allCategoriesState: state.category.categories
    }));

    const [searchTerm, setSearchTerm] = useState('');
    const [filteredCategories, setFilteredCategories] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [hoveredCategory, setHoveredCategory] = useState(null);
    const inputRef = useRef(null);

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        if (value.length < 1) {
            setFilteredCategories([]);
            setShowSuggestions(false);
        } else {
            const filtered = allCategoriesState.filter(cat => 
                cat.Name.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredCategories(filtered);
            setShowSuggestions(filtered.length > 0);
        }
    };

    const handleSelectCategory = (cat) => {
        setShowSuggestions(false);
        updateCategory(idToMove, "FatherId", cat.Id);
        handleClose(() => null);
    };

    const getParentCategory = (cat) => {
        const parentCategory = allCategoriesState.find(c => c.Id === cat.FatherId);
        return parentCategory ? parentCategory.Name : null;
    };

    return (
        <div className="category-dialog-overlay">
            <div className="category-dialog-box">
                <span className="close-icon" onClick={() => handleClose(null)}>×</span>
                <h2>לאיזו קטגוריה ברצונך להעביר?</h2>
                <input 
                    ref={inputRef}
                    type="text" 
                    className="category-input"
                    placeholder="חפש קטגוריה..." 
                    value={searchTerm} 
                    onChange={handleSearch} 
                />
                {showSuggestions && (
                    <ul className="category-suggestions" style={{ position: 'absolute', top: '100%', left: 0, width: '100%' }}>
                        {filteredCategories.map(cat => {
                            const parentName = getParentCategory(cat);
                            return (
                                <li 
                                    key={cat.Id} 
                                    onClick={() => handleSelectCategory(cat)}
                                    onMouseEnter={() => setHoveredCategory(cat.Id)}
                                    onMouseLeave={() => setHoveredCategory(null)}
                                    className="category-item"
                                >
                                    {cat.Name} 
                                    {hoveredCategory === cat.Id && parentName && (
                                        <span className="parent-category"> ⬅ {parentName}</span>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default MoveCategoryDialog;